import { ShiftActionTypes } from './shift.types'
import { API_CONSTANTS } from '../../utils/AppConstants'

const INITIAL_STATE = {
    addShiftSuccess: null,
    addShiftError: null,
    addShiftReqStatus: '',
    updateShiftSuccess: null,
    updateShiftError: null,
    updateShiftReqStatus: '',
    assignShiftSuccess: null,
    assignShiftError: null,
    assignShiftReqStatus: '',
    requestShiftSuccess: null,
    requestShiftError: null,
    requestShiftReqStatus: '',
    shiftRemoveEmployeeSuccess: null,
    shiftRemoveEmployeeError: null,
    shiftRemoveEmployeeReqStatus: '',
    declineRequestSuccess: null,
    declineRequestError: null,
    declineRequestReqStatus: '',
    shiftListSuccess: null,
    shiftListError: null,
    shiftDetailSuccess: null,
    shiftDetailError: null
}

const shiftReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case ShiftActionTypes.ADD_SHIFT_REQUEST_SUCCESS:
            return {
                ...state,
                addShiftSuccess: action.payload,
                addShiftError: null,
                addShiftReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case ShiftActionTypes.ADD_SHIFT_REQUEST_ERROR:
            return {
                ...state,
                addShiftSuccess: null,
                addShiftError: action.payload,
                addShiftReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case ShiftActionTypes.ADD_SHIFT_REQUEST_STATUS:
            return {
                ...state,
                addShiftReqStatus: ''
            }
        case ShiftActionTypes.UPDATE_SHIFT_REQUEST_SUCCESS:
            return {
                ...state,
                updateShiftSuccess: action.payload,
                updateShiftError: null,
                updateShiftReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case ShiftActionTypes.UPDATE_SHIFT_REQUEST_ERROR:
            return {
                ...state,
                updateShiftSuccess: null,
                updateShiftError: action.payload,
                updateShiftReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case ShiftActionTypes.UPDATE_SHIFT_REQUEST_STATUS:
            return {
                ...state,
                updateShiftReqStatus: ''
            }
        case ShiftActionTypes.ASSIGN_SHIFT_REQUEST_SUCCESS:
            return {
                ...state,
                assignShiftSuccess: action.payload,
                assignShiftError: null,
                assignShiftReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case ShiftActionTypes.ASSIGN_SHIFT_REQUEST_ERROR:
            return {
                ...state,
                assignShiftSuccess: null,
                assignShiftError: action.payload,
                assignShiftReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case ShiftActionTypes.ASSIGN_SHIFT_REQUEST_STATUS:
            return {
                ...state,
                assignShiftReqStatus: ''
            }
        case ShiftActionTypes.REQUEST_SHIFT_REQUEST_SUCCESS:
            return {
                ...state,
                requestShiftSuccess: action.payload,
                requestShiftError: null,
                requestShiftReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case ShiftActionTypes.REQUEST_SHIFT_REQUEST_ERROR:
            return {
                ...state,
                requestShiftSuccess: null,
                requestShiftError: action.payload,
                requestShiftReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case ShiftActionTypes.REQUEST_SHIFT_REQUEST_STATUS:
            return {
                ...state,
                requestShiftReqStatus: ''
            }
        case ShiftActionTypes.SHIFT_REMOVE_EMPLOYEE_REQUEST_SUCCESS:
            return {
                ...state,
                shiftRemoveEmployeeSuccess: action.payload,
                shiftRemoveEmployeeError: null,
                shiftRemoveEmployeeReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case ShiftActionTypes.SHIFT_REMOVE_EMPLOYEE_REQUEST_ERROR:
            return {
                ...state,
                shiftRemoveEmployeeSuccess: null,
                shiftRemoveEmployeeError: action.payload,
                shiftRemoveEmployeeReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case ShiftActionTypes.SHIFT_REMOVE_EMPLOYEE_REQUEST_STATUS:
            return {
                ...state,
                shiftRemoveEmployeeReqStatus: ''
            }
        case ShiftActionTypes.DECLINE_REQUEST_SHIFT_REQUEST_SUCCESS:
            return {
                ...state,
                declineRequestSuccess: action.payload,
                declineRequestError: null,
                declineRequestReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case ShiftActionTypes.DECLINE_REQUEST_SHIFT_REQUEST_ERROR:
            return {
                ...state,
                declineRequestSuccess: null,
                declineRequestError: action.payload,
                declineRequestReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case ShiftActionTypes.DECLINE_REQUEST_SHIFT_REQUEST_STATUS:
            return {
                ...state,
                declineRequestReqStatus: ''
            }
        case ShiftActionTypes.SHIFT_LIST_REQUEST_SUCCESS:
            return {
                ...state,
                shiftListSuccess: action.payload,
                shiftListError: null
            }
        case ShiftActionTypes.SHIFT_LIST_REQUEST_ERROR:
            return {
                ...state,
                shiftListSuccess: null,
                shiftListError: action.payload
            }
        case ShiftActionTypes.SHIFT_DETAIL_REQUEST_SUCCESS:
            return {
                ...state,
                shiftDetailSuccess: action.payload,
                shiftDetailError: null
            }
        case ShiftActionTypes.SHIFT_DETAIL_REQUEST_ERROR:
            return {
                ...state,
                shiftDetailSuccess: null,
                shiftDetailError: action.payload
            }
        case ShiftActionTypes.LOGOUT:
            return INITIAL_STATE
        default:
            return state
    }
}

export default shiftReducer